import type { ReactNode } from 'react'

import { cn, LABEL_CLASS } from '@/components/base'

/** The type styles alone, for callers that need a string rather than the
 *  element — `EditableText`'s `textClassName` prop. */
export const GROUP_LABEL_CLASS = LABEL_CLASS

/**
 * The small uppercase label above a group of fields, rows or columns
 * ("Gebäude", "Energie & Technik", "Dokumente"). Cross-area — Customer,
 * Internal and Public all use it, so it carries no margin of its own; the
 * caller spaces it, which is what lets it drop into a gap-spaced stack.
 *
 * Not to be confused with `Internal/PaneHeading`, which is the band over a
 * whole pane: it names one thing, so its title is set like a name.
 */
export function GroupLabel({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) {
  return <span className={cn('block', LABEL_CLASS, className)}>{children}</span>
}
